import { z } from "zod";
import { createCommonHeaders } from "./commonHeaders";
import { interaction, post_Interaction } from "./user-interaction-service.openapi.zod";
import { USER_INTERACTION_SERVICE_BASE_URL } from "env";

export { interaction as InteractionRequestBodySchema } from "./user-interaction-service.openapi.zod";
export type InteractionRequestBody = z.infer<typeof interaction>;
type InteractionResponseBody = z.infer<typeof post_Interaction.response>;

export async function sendInteraction(interactionData: InteractionRequestBody): Promise<InteractionResponseBody> {
    // Use the same pattern as other services - direct URL from config
    const url = `${USER_INTERACTION_SERVICE_BASE_URL}/interaction`;
    const headers = {
        ...createCommonHeaders(globalThis),
        "Content-Type": "application/json",
    };
    const body = JSON.stringify(interactionData);

    const response = await fetch(url, {
        method: "POST",
        body,
        headers,
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("Error in response:", {
            status: response.status,
            statusText: response.statusText,
            body: errorText,
            url,
            headers,
            requestBody: body,
        });
        throw new Error(`Failed to send interaction: ${response.status} ${response.statusText} - ${errorText}`);
    }

    return response.bodyUsed ? post_Interaction.response.parse(await response.json()) : undefined;
}
